var version = "0.0.0";

export { version };
//# sourceMappingURL=package.json.mjs.map
